import { render, staticRenderFns } from "./batch-details.vue?vue&type=template&id=073ab3ca&scoped=true&"
import script from "./batch-details.vue?vue&type=script&lang=js&"
export * from "./batch-details.vue?vue&type=script&lang=js&"
import style0 from "./batch-details.vue?vue&type=style&index=0&id=073ab3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ab3ca",
  null
  
)

export default component.exports